import { Badge } from 'react-bootstrap';
import GameTypeBadge from '../../../GameTypeBadge';

function PublicFavouriteGameDisplayer({ favouriteGames }) {
    return (
        <div>
            {favouriteGames.map((game) => (
                <div key={game.favouriteGameId} className="card border-0 shadow-sm mb-3">
                    <div id={game.name.charAt(0)} />
                    <div className="card-body p-3 d-flex gap-3 align-items-start">
                        {game.imageLink && (
                            <img
                                src={game.imageLink}
                                alt={game.name}
                                className="rounded flex-shrink-0"
                                style={{ width: 72, height: 72, objectFit: 'cover' }}
                            />
                        )}
                        <div className="flex-grow-1 min-w-0">
                            <div className="d-flex align-items-center gap-2 flex-wrap mb-1">
                                <a
                                    href={game.link}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="fw-semibold text-dark text-decoration-none"
                                >
                                    {game.name}
                                </a>
                                <GameTypeBadge gameType={game.gameType} />
                            </div>
                            {game.description && (
                                <p className="text-clamp text-muted small mb-2 mt-1">
                                    {game.description}
                                </p>
                            )}
                            {game.gameLabels && game.gameLabels.length > 0 && (
                                <div className="d-flex flex-wrap gap-1">
                                    {game.gameLabels.map((label) => (
                                        <Badge key={label.gameLabelId} bg="secondary">
                                            {label.name}
                                        </Badge>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default PublicFavouriteGameDisplayer;
